import type { TaskRecord } from "@nexus/contracts";

/** True while a persona-scripts task for this set still has incomplete progress. */
export function isPersonaScriptsGenerationActiveForSet(
  tasks: TaskRecord[] | undefined,
  setId: string | null | undefined,
): boolean {
  if (!tasks?.length || !setId) return false;
  return tasks.some(
    (task) =>
      task.type === "generate-persona-scripts" &&
      task.navigation?.params?.setId === setId &&
      task.stages.some((stage) => stage.subtasks.some((subtask) => subtask.progress < 1)),
  );
}
